<template>
  <div class="modal modal-fixed-footer" ref="modal">
    <div class="modal-content row">
      <input type="file" @change="$_addImage" ref="file" style="display: none" accept="image/jpeg" />
      <ul class="tabs col s12" ref="tabs">
        <li class="tab">
          <a href="#url" @click="setTab('link')">From Url</a>
        </li>
        <li class="tab"><a @click="setTab('uploads')" href="#uploads">Images</a></li>
      </ul>
      <div class="clear"></div>
      <div id="url" v-show="ready && activeTab === 'link'">
        <div class="input-field col s10 push-l1">
          <div class="url" style="margin-bottom:12px; font-size:24px;">
            Insert image link
          </div>
          <input type="url" name="url" placeholder="https://...." :class="$v.$invalid ? 'invalid' : 'valid'" id="url"
            v-model="link" />
        </div>
      </div>
      <div id="uploads" v-show="ready && activeTab === 'uploads'">
        <div class="images" v-if="images && images.length > 0">
          <div class="row">
            <div class="col s6 m4" v-for="image in images" :key="image.id">
              <div class="card" @click="selectImage(image)" :class="image.link === link ? 'active' : ''">
                <div class="card-image">
                  <img :src="image.link" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top:25px;" class="col s12 center-align">
          <button v-if="!isProcessing"
            class="btn grey lighten-4 waves-effect btn-rounded z-depth-0 grey-text text-darken-3 icon-right"
            @click="$_openFile('add_more')">
            <i class="material-icons-outlined right grey-text text-darken-3">add</i>
            Add Image
          </button>
          <button v-else
            class="btn btn-uploading grey lighten-4 waves-effect btn-rounded z-depth-0 grey-text text-darken-3 icon-right"
            disabled @click="$_openFile('add_more')">
            Uploading Image
            <div :class="{ active: !isProcessing }" class="preloader-wrapper small ">
              <div class="spinner-layer spinner-white-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div>
                <div class="gap-patch">
                  <div class="circle"></div>
                </div>
                <div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </button>
        </div>
        <div class="clear"></div>
        <div class="special-guidelines col s12">
          <div class="card z-depth-0 grey lighten-4">
            <div class="card-content">
              <b>Note</b>: The maximum file size for each image uploaded is 5MB
              (megabytes). If you need assistance with reducing the file size of
              your images, please click
              <a href="https://www.reduceimages.com/" target="_blank">here</a>
              for assistance. You cannot upload more than 10 images per
              category.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="modal.instance.close()" class="btn-flat waves-effect transparent left">
        Close
      </button>
      <button class="btn waves-effects white red-text text-darken-3" style="margin-right:12px" :disabled="$v.$invalid"
        @click="deleteImage()">
        Delete Image
      </button>
      <button class="btn waves-effects indigo accent-2" :disabled="$v.$invalid" @click="SetUrl()">
        Insert Image
      </button>
    </div>
  </div>
</template>
<script>
import { url, required } from "vuelidate/lib/validators";
import { getCookie } from "@/common/util";
import { updateUserProfile, deleteMediaFile } from "@/api/user.api";
import { mapState, mapActions } from "vuex";
import M from "materialize-css";
import { toastMessage } from "@/common/util";

import axios from "axios";
export default {
  name: "editorPhotos",
  props: {},
  data() {
    return {
      link: "",
      ready: false,
      photos: {},
      isProcessing: false,
      selectedImage: null,
      activeTab: 'link',
      modal: {
        instance: null,
        options: {
          onOpenEnd: () => {
            this.ready = true;
            this.InitTabs();
          },
          onCloseEnd: () => {
            this.modal.instance.destroy();
            this.$emit("state", false);
          },
        },
      },
      tabs: {
        instance: null,
        options: {},
      },
    };
  },
  computed: {
    ...mapState({ user: (state) => state.User.user }),
    images: {
      get() {
        return Object.values(this.photos).flatMap((x) => [...x.images]);
      },
    },
  },
  validations() {
    return {
      link: {
        required,
        url,
      },
    };
  },

  mounted() {
    this.InitModal();
    this.$_getData();
  },
  methods: {
    ...mapActions("User", ["updateUser"]),
    setTab(e) {
      if (e === 'link') this.link = ""
      this.activeTab = e
    },
    $_openFile() {
      this.$refs.file.click();
    },
    $_addImage($event) {
      const files = $event.target.files;

      let image = "";

      Object.keys(files).some((key) => {
        if (files[key].size > 2 * 1024 * 1024) {
          toastMessage("Maximum file size is 2MB.");
          return true;
        }

        if (files[key].type !== "image/jpeg") {
          toastMessage("JPEG image only.");
          return true;
        }

        image = files[key];
      });

      this.$_uploadImage(image);
    },
    selectImage(image) {
      this.link = image.link;
      this.selectedImage = image;
    },
    async $_uploadImage(image) {
      if (this.isProcessing || !image) return;

      this.isProcessing = true;
      try {
        let formData = new FormData();
        const newName = new Date().getTime() + image.name;
        formData.append("file", image, newName);

        const token = getCookie("token");

        const { data } = await axios.post(
          "https://api.sldb.lc/wp-json/wp/v2/media",
          formData,
          {
            headers: {
              Authorization: "Bearer" + token,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        let dataObj = { ...this.photos };

        let { adaptation_plan } = dataObj;

        if (!adaptation_plan) {
          dataObj["adaptation_plan"] = {
            id: "",
            key: "adaptation_plan",
            images: [],
            link: "",
            text: "Adaptation Plan",
            value: "",
          };
        }

        dataObj.adaptation_plan.images.push({
          id: data.id,
          link: data.source_url,
        });

        let payload = {
          fields: {
            home_profile_images: JSON.stringify(dataObj),
          },
        };

        /*   console.log(dataObj); */

        await updateUserProfile(this.user.profile, payload);

        this.updateUser({ ...payload.fields });

        this.isProcessing = false;

        this.$_getData();
      } catch (error) {
        toastMessage("Fail to upload image.");
        this.isProcessing = false;
      }
    },

    async deleteImage() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      try {
        const { id } = this.selectedImage;

        await deleteMediaFile(id);

        for (const key in this.photos) {
          this.photos[key].images &&
            (this.photos[key].images = this.photos[key].images.filter(
              (image) => image.id !== id
            ));
        }

        let payload = {
          fields: {
            home_profile_images: JSON.stringify(this.photos),
          },
        };

        await updateUserProfile(this.user.profile, payload);

        this.updateUser({ ...payload.fields });

        this.isProcessing = false;

        this.$_getData();
      } catch (error) {
        toastMessage("Fail to delete image.");
        this.isProcessing = false;
      }
    },

    $_getData() {
      if (this.user.home_profile_images) {
        this.photos = JSON.parse(this.user.home_profile_images);
      }
    },
    SetUrl() {
      this.$emit("url", this.link);
      setTimeout(() => {
        this.modal.instance.close();
      }, 100);
    },
    InitModal() {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
      setTimeout(() => {
        this.modal.instance.open();
      }, 100);
    },
    InitTabs() {
      this.tabs.instance = M.Tabs.init(this.$refs.tabs, this.tabs.options);
    },
  },
};
</script>
<style scoped lang="scss">
.modal {
  border-radius: 8px;

  .modal-content {
    padding: 0px;
  }
}

.btn-uploading {
  margin: 0 auto;
  display: flex;
  align-items: center;

  .preloader-wrapper {
    margin-left: 1rem;
    width: 25px;
    height: 25px;
    // position: absolute;
    // position: absolute;
    // top: 8px;
    // right: 17px;
  }
}

.images {
  .row {
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;

    .col {
      margin-left: 0px;
      margin-right: 0px;
      float: none;
    }
  }

  .card {
    position: relative;

    &.active {
      &::before {
        content: "";
        border: 2px solid blue;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 9;
      }
    }
  }
}
</style>
